import { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { FiArrowUp, FiPhoneCall } from 'react-icons/fi';
import { FaWhatsapp } from 'react-icons/fa';
import { logEvent } from 'firebase/analytics';
import { analytics } from './firebase';
import Homepage from './Components/Homepage';
import Aboutus from './Components/Home/Aboutus';
import QualityPage from './Components/Home/QualityPage';
import Contactus from './Components/Home/Contactus';
import Prefab from './Components/Home/Prefab';
import SteelFabrication from './Components/Home/SteelFabrication';
import RoofWallSheeting from './Components/Home/RoofWallSheeting';
import Projects from './Components/Home/Projects';
import Brochure from './Components/Home/Brochure';
import IndustrialSheds from './Components/Home/industrial';
import IndustrialStructures from './Components/Home/IndustrialStructures';
import FabricationServices from './Components/Home/FabricationServices';
import Enquiry from './Components/Home/Enquiry';
import Gallery from './Components/Home/Gallery';
import LocationsHub from './Components/Locations/LocationsHub';
import StatePage from './Components/Locations/StatePage';
import CityPage from './Components/Locations/CityPage';
import BlogIndex from './Components/Blog/BlogIndex';
import BlogPost from './Components/Blog/BlogPost';
import Products from './Components/Products';
import IndustriesHub from './Components/Industries/IndustriesHub';
import IndustryPage from './Components/Industries/IndustryPage';
import ServicePage from './Components/Services/ServicePage';
import PEBCostCalculator from './Components/PEBCostCalculator';
import SiteMap from './Components/SiteMap';
import GeneralFAQ from './Components/GeneralFAQ';
import NotFound from './Components/NotFound';
import { business } from './config/business';
import './App.css'; // Create this file if you don't have it

// Firebase Analytics doesn't auto-track route changes in a client-rendered
// SPA the way a full page load would, so without this there's no visibility
// into whether visitors are even reaching the site at all — the first thing
// to rule out when "leads aren't coming in."
const PageViewTracker = () => {
  const location = useLocation();
  useEffect(() => {
    logEvent(analytics, "page_view", {
      page_path: location.pathname,
      page_location: window.location.href,
    });
  }, [location.pathname]);
  return null;
};

export default function App() {
  return (
    <Router>
      <PageViewTracker />
      <Routes>
        <Route path="/" element={<Homepage />} />
        <Route path="/about" element={<Aboutus />} />
        <Route path="/quality" element={<QualityPage />} />
        <Route path="/contact" element={<Contactus />} />
        <Route path="/pre-fab-structure-buildings" element={<Prefab />} />
        <Route path="/structure-steel-fabrication" element={<SteelFabrication />} />
        <Route path="/roof-wall-sheeting" element={<RoofWallSheeting />} />
        <Route path="/projects" element={<Projects />} />
        <Route path="/brochure" element={<Brochure />} />
        <Route path="/FabricationServices" element={<FabricationServices />} />
        <Route path="/enquiry" element={<Enquiry />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/industrial-sheds" element={<IndustrialSheds />} />
        <Route path='/IndustrialStructures' element={<IndustrialStructures />} />
        <Route path="/products" element={<Products />} />
        <Route path="/locations" element={<LocationsHub />} />
        <Route path="/locations/:stateSlug" element={<StatePage />} />
        <Route path="/locations/:stateSlug/:citySlug" element={<CityPage />} />
        <Route path="/resources" element={<BlogIndex />} />
        <Route path="/resources/:slug" element={<BlogPost />} />
        <Route path="/industries" element={<IndustriesHub />} />
        <Route path="/industries/:slug" element={<IndustryPage />} />
        <Route path="/services/:slug" element={<ServicePage />} />
        <Route path="/peb-erection" element={<ServicePage />} />
        <Route path="/design-engineering" element={<ServicePage />} />
        <Route path="/peb-cost-calculator" element={<PEBCostCalculator />} />
        <Route path="/sitemap" element={<SiteMap />} />
        <Route path="/faq" element={<GeneralFAQ />} />
        <Route path="*" element={<NotFound />} />
      </Routes>

      {/* Call Widget - Responsive */}
      <a href={business.phone.href} className="call-widget"
        aria-label={`Call Vasavi Structures at ${business.phone.display}`}
        onClick={() => logEvent(analytics, 'call_click', { source: 'floating_widget' })}
      >
        <FiPhoneCall className="call-icon" />
      </a>

      {/* WhatsApp Chat Widget - Responsive */}
      <div className="whatsapp-widget"
        onClick={() => {
          logEvent(analytics, 'whatsapp_click', { source: 'floating_widget' });
          window.open(business.whatsapp.href, '_blank');
        }}
      >
        <FaWhatsapp className="whatsapp-icon" />
      </div>

      {/* Scroll to Top - Responsive */}
      <div className="scroll-top"
        onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
      >
        <FiArrowUp className="arrow-icon" />
      </div>
    </Router>
  );
}